import type { ReadingType } from "../Components/QuestionInput/QuestionInput";

export type Phase = "question" | "drawing" | "spread" | "reading";

export interface CardInfo {
  name: string;
  isReversed: boolean;
  image: string;
}

export const READING_PHASES = new Set<Phase>(["reading", "spread"]);

export const READING_TYPE_TO_PHASE: Record<ReadingType, Phase> = {
  single: "drawing",
  "yes-or-no": "drawing",
  "past-present-future": "spread",
  relationship: "spread",
  "you-position-potential": "spread",
  "unconscious-conscious-superconscious": "spread",
  "embrace-accept-let-go": "spread",
  "situation-obstacle-lesson": "spread",
};
